import {
	Box,
	Breadcrumbs,
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	FormGroup,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	SelectChangeEvent,
	Stack,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import {
	DataGridPremium,
	GridColDef,
	GridColumnVisibilityModel,
	GridDensity,
	GridSelectionModel,
	koKR,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import { getSettings } from 'helpers/storage'
import { selectCmmnCode } from 'hooks/cmmnCodeFactory'
import { selectuserInfo } from 'hooks/userInfo'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'
import moment from 'moment'
import {
	alertModal,
	isValidDateType,
	compareDate,
	hexToRgba,
	autoCellPhone,
} from 'util/util'
import ClientSearchPopup from 'views/test/clientSearchPopup'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { apiReportTypeList, apiRptCodeListByReportCode, httpGet } from 'api/api'
import { PageBg } from 'components/ComponentStyles'
import React from 'react'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import SmsIcon from '@mui/icons-material/Sms'

const PageBg2 = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '1rem',
	borderRadius: '0.5rem',
	background: `${hexToRgba(theme.palette.custom.wrapper, 1)}`,
	// filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		flexDirection: 'column',
		borderRadius: 0,
	},
	// backdropFilter: 'blur(10px)',
}))

const PageWrap = styled('div')(({ theme }) => ({
	marginBottom: '1rem',
	position: 'relative',
	top: '0',
	left: '0',
	right: '0',
	zIndex: '110',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		//marginLeft: '-1.5rem',
		//marginRight: '-1.5rem',
		top: '0',
		//borderRadius: '0',
	},
}))

const BtnBox = styled(Box)(({ theme }) => ({
	// [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
	// 	marginTop: '1rem',
	// },
}))

const TitleText = styled(Typography)(({ theme }) => ({
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		display: 'none',
	},
}))

const SearchRowItem = styled(Box)(({ theme }) => ({
	position: 'relative',
	display: 'block',
	paddingLeft: '80px',
	minHeight: '44px',
	marginBottom: '10px',
	'&.noLabel': {
		paddingLeft: '0',
	},
	'.labelText': {
		position: 'absolute',
		left: '10px',
		top: '15px',
		[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
			position: 'relative',
			left: '0',
			top: '0',
			marginBottom: '0.5rem',
		},
	},
	[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
		paddingLeft: '0',
		height: 'auto',
	},
}))

const locales = ['ko'] as const

type SearchType = {
	clientID: string // 거래처id
	startDate: string // 시작일자
	endDate: string // 종료일자
	chartNo: string // 차트번호
	patientName: string // 수진자명
	cellNumber: string // 휴대폰번호
	status: string // 상태
	scheduleType: string // 예약구분
	rptTypeCode: string // 보고서 종류 코드
}

const initialSearch: SearchType = {
	clientID: '',
	startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
	endDate: moment().format('YYYY-MM-DD'),
	chartNo: '',
	patientName: '',
	cellNumber: '',
	status: '',
	scheduleType: '',
	rptTypeCode: '',
}

type PartCodeType = {
	partName: string
	partCode: string
}

type RptCodeType = {
	rptTypeCode: string
	reportName: string
	webReportName: string
	partCode: string
	active: boolean
}

type ListType = {
	RowNum: number
	CellNumber: string
	ChartNo: string
	MmsMsg: string
	PatientName: string
	RptTypeCode: string
	SendDate: string
	Subject: string
}

type ReportListSearchType = {
	clientID: number | null
	reportTypeCode: string
	partCode: string
	isActive: boolean | null
}

const reportListSearch: ReportListSearchType = {
	clientID: null,
	reportTypeCode: '0',
	partCode: '0',
	isActive: null,
}

type RptTypeCodeListType = {
	rptTypeCode: string
	reportName: string
	webReportName: string
	partCode: number
	IsActive: number
	ResultType: 'A' | 'N' | 'P'
	TemplateID: number
	ClientID: number
	TemplateName: string
	TemplateText: string
	isMine?: number
}

const columns: GridColDef[] = [
	{
		field: 'RowNum',
		headerName: '순번',
		width: 60,
		editable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'PatientName',
		headerName: '수진자명',
		width: 120,
		editable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'ChartNo',
		headerName: '차트번호',
		width: 120,
		editable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'CellNumber',
		headerName: '휴대폰번호',
		width: 120,
		editable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'Subject',
		headerName: '제목',
		width: 200,
		editable: false,
		headerAlign: 'center',
		align: 'left',
	},
	{
		field: 'MmsMsg',
		headerName: '내용',
		width: 300,
		editable: false,
		headerAlign: 'center',
		align: 'left',
		renderCell: (params) => {
			const message = String(params.value ?? '').replace(/\\n/g, '\n')
			return (
				<Box
					sx={{
						whiteSpace: 'pre-wrap',
						wordBreak: 'break-word',
						lineHeight: 1.4,
						py: 1,
					}}
				>
					{message}
				</Box>
			)
		},
	},
	{
		field: 'SendDate',
		headerName: '발송일시',
		width: 150,
		editable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'ResultMessage',
		headerName: '발송결과',
		width: 150,
		editable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'TcsResultMessage',
		headerName: '사유',
		width: 350,
		editable: false,
		headerAlign: 'center',
		align: 'center',
		renderCell: (params) => {
			// TcsResult 값이 0이면 메세지 표기하지 않고, 0이 아니면 TcsResultMessage 값 표기
			if (params.row.TcsResult === 0) {
				return ''
			} else {
				return params.value
			}
		},
	},
]

const AuthSmsComplate = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const isSmDown = useMediaQuery(theme.breakpoints.down('sm'))
	const isSmUp = useMediaQuery(theme.breakpoints.up('sm'))

	const grid1Ref = useGridApiRef()

	const [gridIsLoading, setGridIsLoading] = useState<boolean>(false)

	const userInfo = useSelector(selectuserInfo)
	const env = getSettings()
	// ui
	const cmmnCdList = useSelector(selectCmmnCode)
	const [disabledSearch, setDisabledSearch] = useState(false)
	const disabledReset = false

	const [dateRange, setDateRange] = useState('1d')
	const [locale, setLocale] = useState<(typeof locales)[number]>('ko')
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])
	const [size, setSize] = useState(env.row ? env.row : 100)
	const [page, setPage] = useState(0)

	const [search, setSearch] = useState<SearchType>(initialSearch)
	// 보고서 종류 코드 목록
	const [rptTypeList, setRptTypeList] = useState<RptCodeType[]>([])
	// 조회조건 (검체종류)
	const [testCdList, setTestCdList] = useState<any>([])
	const [list, setList] = useState<ListType[]>([])

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}

	const actionSearch = () => {
		setGridIsLoading(true)
		// startDate, endDate는 yyyymmdd000000 부터 yyyymmdd235959 까지 조회되도록 변환
		const request = {
			...search,
			startDate: moment(search.startDate).format('YYYYMMDD') + '000000',
			endDate: moment(search.endDate).format('YYYYMMDD') + '235959',
		}
		httpGet('autoSms/client/messageResult', request)
			.then((res) => {
				console.log(res)
				setList(res)
			})
			.finally(() => {
				setGridIsLoading(false)
			})
	}

	const actionReset = () => {}

	// calcaulate today before n days
	const getBeforeDate = (n: number) => {
		setSearch({
			...search,
			startDate: moment(search.endDate).subtract(n, 'days').format('YYYY-MM-DD'),
		})
	}

	const searchDateRanageOnChange = (event: any) => {
		switch (event.target.value) {
			case '1d':
				getBeforeDate(1)
				break
			case '3d':
				getBeforeDate(3)
				break
			case '7d':
				getBeforeDate(7)
				break
			case '14d':
				getBeforeDate(14)
				break
			default:
				getBeforeDate(7)
				break
		}
		setDateRange(event.target.value)
		setDisabledSearch(false)
	}

	// date picker on change event

	const dateRanageOnChange = (e: any, target: string) => {
		// setIsDateRangeChanged(false)
		if (moment(new Date(e)).isBefore('2023-08-01')) {
			alertModal('2023-08-01 이전 날짜는 조회할 수 없습니다.', 'error', () => {})
			setSearch({
				...search,
				[target]: moment(new Date(e)).format('yyyy-MM-DD'),
			})
			return
		} else {
			if (moment(new Date(e)).format('yyyy-MM-DD').length === 10) {
				if (!isValidDateType(e)) {
					alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
					setDisabledSearch(true)
					return
				}

				if (target === 'startDate') {
					let diffValue = compareDate(e, search.endDate)
					if (diffValue > 0) {
						alertModal('시작일이 종료일보다 큽니다.', 'error', () => {})
						setDisabledSearch(true)

						setSearch((prevState) => {
							return {
								...prevState,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue < -1825) {
						alertModal('검색기간은 5년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				} else if (target === 'endDate') {
					let diffValue = compareDate(e, search.startDate)
					if (diffValue < 0) {
						alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
						setDisabledSearch(true)

						setSearch((prevState) => {
							return {
								...prevState,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue > 1825) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				}

				setDisabledSearch(false)

				setSearch((prevState) => {
					return {
						...prevState,
						[target]: moment(new Date(e)).format('yyyy-MM-DD'),
					}
				})
			} else {
				setDisabledSearch(true)
			}
		}
	}

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		console.log(e)
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		getRptCodeListByReportCode(e.ClientID)
		setClientDialogOpen(false)
	}

	/**
	 * 검체종류 select
	 * @param e
	 */
	const searchTestCdOnChange = (e: SelectChangeEvent<string>): void => {
		const selectedPartCode = e.target.value

		apiRptCodeListByReportCode(selectedPartCode).then((res) => {
			console.log(res)
			setRptTypeList(res)

			setSearch((prev) => ({
				...prev,
				partCode: selectedPartCode,
				reportTypeCode: res?.[0]?.rptTypeCode ?? '0',
			}))
		})
	}

	const [columnVisibilityModel, setColumnVisibilityModel] =
		React.useState<GridColumnVisibilityModel>({
			ReceptionID: false,
			rowNum: true,
			ReceptionDate: true,
			ReceptionInfo: true,
			PatientName: true,
			ChartNo: true,
			ClientInfo: true,
			DepartName: true,
			PartName: true,
			RptTypeName:
				userInfo.clientID === 6499 ||
				userInfo.clientID === 6502 ||
				userInfo.infoType === 'S' ||
				userInfo.infoType === 'W'
					? true
					: false,
			FindingsCnt: false,
			StateCategory: true,
			Decision: true,
			isView: true,
		})

	const smsAction = () => {}

	// SMS 활성화된 보고서 목록
	const [rptTypeCodeList, setRptTypeCodeList] = useState<RptTypeCodeListType[]>(
		[],
	)
	const getRptCodeListByReportCode = (clientID: number) => {
		const search: ReportListSearchType = {
			...reportListSearch,
			clientID: clientID,
		}
		httpGet('autoSms/client/template/list', search).then((res) => {
			console.log(res)
			const filteredList = res.filter(
				(item: RptTypeCodeListType) => item.IsActive === 1,
			)
			setRptTypeCodeList(filteredList)
		})
	}

	useEffect(() => {
		console.log(userInfo)
		console.log(userInfo.infoType === 'W' || userInfo.infoType === 'S')
		// 사용자 타입이 거래처일 경우만 자동 조회
		if (userInfo.infoType === 'C') actionSearch()

		apiReportTypeList().then((res) => {
			console.log(res)
			setTestCdList(res)
		})

		apiRptCodeListByReportCode('0').then((res) => {
			console.log(res)
			setRptTypeList(res)
		})
		apiReportTypeList().then((res) => {
			console.log(res)
			setTestCdList(res)
			getRptCodeListByReportCode(userInfo.clientID)
		})
	}, [])

	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								전송 완료 목록
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										color="primary"
										variant="contained"
										startIcon={<ContentPasteSearchTwoToneIcon />}
										onClick={actionSearch}
										size="small"
										disabled={disabledSearch}
										sx={{ marginRight: '0.5rem' }}
									>
										조회
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
					>
						<SearchRowItem>
							<p className="labelText">조회조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="시작일"
										value={search.startDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'startDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="종료일"
										value={search.endDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'endDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									{isLgUp ? (
										<>
											<FormControl sx={{ pt: 0.8 }}>
												<RadioGroup
													row
													aria-labelledby="date-controlled-radio-buttons-group"
													name="date-radio-buttons-group"
													value={dateRange}
													onChange={searchDateRanageOnChange}
													sx={{ ml: '0.5rem' }}
												>
													<FormControlLabel
														value="1d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="1일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="3d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="3일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="7d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="7일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="14d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="14일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
												</RadioGroup>
											</FormControl>
										</>
									) : (
										<>
											<FormControl fullWidth>
												<InputLabel id="date-range-select-label">조회 기간</InputLabel>
												<Select
													labelId="date-range-select-label"
													id="date-range-simple-select"
													value={dateRange ?? '1d'}
													label="조회 기간"
													onChange={searchDateRanageOnChange}
													size={'small'}
												>
													<MenuItem value={'0'}>선택하세요.</MenuItem>
													<MenuItem value={'1d'}>1일</MenuItem>
													<MenuItem value={'3d'}>3일</MenuItem>
													<MenuItem value={'7d'}>7일</MenuItem>
													<MenuItem value={'14d'}>14일</MenuItem>
												</Select>
											</FormControl>
										</>
									)}
								</Grid>
							</Grid>
						</SearchRowItem>
						<SearchRowItem>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="차트번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.chartNo}
										onChange={(e) => {
											setSearch({
												...search,
												chartNo: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="수진자명"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.patientName}
										onChange={(e) => {
											setSearch({
												...search,
												patientName: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="전화번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.cellNumber}
										onChange={(e) => {
											setSearch({
												...search,
												cellNumber: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="보고서 종류"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										select
										value={search.rptTypeCode ?? ''}
										SelectProps={{ displayEmpty: true }}
										InputLabelProps={{ shrink: true }}
										onChange={(e) => {
											setSearch({
												...search,
												rptTypeCode: e.target.value,
											})
										}}
									>
										<MenuItem value={''}>전체</MenuItem>
										{rptTypeCodeList.map((item, index) => (
											<MenuItem
												key={index}
												value={item.rptTypeCode}
											>
												{item.reportName}
											</MenuItem>
										))}
									</TextField>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="발송 상태"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										select
										value={search.status ?? ''}
										SelectProps={{ displayEmpty: true }}
										InputLabelProps={{ shrink: true }}
										onChange={(e) => {
											setSearch({
												...search,
												status: e.target.value,
											})
										}}
									>
										<MenuItem value={''}>전체</MenuItem>
										<MenuItem value={'1'}>성공</MenuItem>
										<MenuItem value={'0'}>실패</MenuItem>
									</TextField>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
									lg={2}
								>
									<TextField
										label="발송 구분"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										select
										value={search.scheduleType ?? ''}
										SelectProps={{ displayEmpty: true }}
										InputLabelProps={{ shrink: true }}
										onChange={(e) => {
											setSearch({
												...search,
												scheduleType: e.target.value,
											})
										}}
									>
										<MenuItem value={''}>전체</MenuItem>
										<MenuItem value={'1'}>예약</MenuItem>
										<MenuItem value={'0'}>즉시</MenuItem>
									</TextField>
								</Grid>
							</Grid>
							<Grid
								container
								spacing={1}
								sx={{ mt: 0.2 }}
							>
								{(userInfo.infoType === 'S' || userInfo.infoType === 'W') && (
									<Grid
										item
										xs={6}
										sm={3}
										md={2}
									>
										<TextField
											label="거래처"
											variant="outlined"
											size="small"
											type="text"
											fullWidth
											aria-readonly={true}
											value={searchClientName}
											onClick={clientPopupOpenAction}
										/>
									</Grid>
								)}
							</Grid>
						</SearchRowItem>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				id="back-to-top"
				elevation={0}
				sx={{
					width: '100%',
					// overflow: 'hidden',
					backgroundColor: 'transparent',
					// overflow: 'auto',
				}}
			>
				<Grid container>
					<Grid
						item
						xs={12}
					>
						<PageBg style={{ marginTop: '1rem' }}>
							<Typography
								variant="subtitle1"
								component="h3"
								sx={{ lineHeight: '1rem' }}
							>
								수진자 리스트
							</Typography>
							<Box
								sx={{
									marginTop: '1rem',
									height: 813,
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<DataGridPremium
									apiRef={grid1Ref}
									page={page}
									onPageChange={(newPage) => setPage(newPage)}
									rows={list}
									getRowId={(row) => row.RowNum}
									columns={columns}
									getRowClassName={(params) =>
										params.row.StateCategory !== '완료' ? 'no-image-row' : ''
									}
									pageSize={size}
									onPageSizeChange={(newPageSize) => setSize(newPageSize)}
									rowsPerPageOptions={[5, 10, 20, 50, 100, 500, 1000]}
									pagination
									autoHeight={false}
									// autoHeight={isLgUp ? true : false}
									localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
									components={{
										LoadingOverlay: LinearProgress,
									}}
									isRowSelectable={(params) =>
										params.row.StateCategory === '완료' ? true : false
									}
									loading={gridIsLoading}
									selectionModel={selectionModel}
									onSelectionModelChange={(newSelection) => {
										// console.log(pdfLimit)
										// if (pdfLimit >= newSelection.length) {
										// 	setSelectionModel(newSelection)
										// }
										setSelectionModel(newSelection)
									}}
									getRowHeight={() => 'auto'}
									getEstimatedRowHeight={() => 80}
									density={(env.desnse as GridDensity) || 'compact'}
									sx={{
										'& .MuiDataGrid-columnHeaderTitleContainer': {
											fontSize: '13px',
										},
										'& .MuiDataGrid-row.no-image-row:hover': {
											backgroundColor:
												theme.palette.mode === 'dark'
													? 'rgba(50, 48, 54, 1) !important'
													: '#fff !important',
										},
										'& .MuiDataGrid-row:hover': {
											backgroundColor: 'rgba(0,0,0, 0.1) !important',
										},
										'& .Mui-selected:hover': {
											backgroundColor: 'rgba(75, 123, 236, 0.08) !important',
										},
										'& .MuiDataGrid-cell': {
											fontSize: '13px !important',
											borderRight:
												theme.palette.mode === 'dark'
													? '1px solid rgba(81, 81, 81, 1)'
													: '1px solid rgba(224, 224, 224, 1)',
										},
										'& .Mui-disabled': {
											color: 'rgba(0, 0, 0, 0.1) !important',
										},
									}}
									disableMultipleSelection={true}
									initialState={{
										columns: {
											columnVisibilityModel,
										},
									}}
									onColumnVisibilityModelChange={(newModel) => {
										console.log(newModel)
										setColumnVisibilityModel(newModel)
									}}
								/>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}

export default AuthSmsComplate
